import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Grid,
  Box,
  Link,
} from "@mui/material";
import { useAuth } from "oidc-react";
import { filterAllowedColumn } from "../../../_helper/helper";
import ErrorBoundary from "../../../ErrorBoundry";
import AdvanceSearch from "../../../CommonComponents/AdvanceSearch";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import DatePicker from "../../../CommonComponents/FormComponents/DatePicker";
import { faEye, faPlus, faSave, faTrash } from "@fortawesome/pro-duotone-svg-icons";
import CustomButton from "../../../CommonComponents/FormComponents/Button";


import { LoadingPanel } from "../../../CommonComponents/CommonFunction";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable/indexV3";
import CustomAutocomplete from "../../../CommonComponents/FormComponents/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setAdditionalWhere } from "../../../store/Common/actions";
// import AddSupervisorModal from "./AddSupervisorsModal";
import { toSQLExpression } from "../../../utils/common";
import axios from "axios";
import { get } from "../../../_helper/api_helper";
import { toast } from "react-toastify";


const GET_SUPERVISOR_DETAILS_BY_ID = "Payroll/GetSupervisorDetailById";
const ADD_UPDATE_ALL_PAYROLL_EMPLOYEE = "Payroll/AddUpdateAllSupervisorEmployee";
const ADD_ROLE_PAYROLL_EMPLOYEE = "Payroll/AddSupervisorEmployee";
const UNASSIGN_ALL_PAYROLL_EMPLOYEE = "Payroll/RemoveAllSupervisorEmployee"
const UNASSIGN_PAYROLL_EMPLOYEE = "Payroll/RemoveSupervisorEmployee";
const ASSIGN_EMPLOYEE_TO_SUPERVISOR = 'Payroll/AssignEmployeeToSupervisor'
const URL_AdvanceSearch_GetRecords =  "AdvanceSearch";


const INITIAL_DATA = {
  SupervisorId: 0,
  EmployeeId: 0,
  SupervisionRole: "",
  StartDate: "",
  EndDate: "",
};

const CONDITIONS = {
  "all": ``,
  "Supervisor": `SupervisionRole = 'Supervisor'`,
  "Timekeeper": `SupervisionRole = 'Timekeeper'`,
  "Reviewer": `SupervisionRole = 'Reviewer'`,
};

const DataTable = ({
  tableName,
  isLoading,
  title,
  sort = [],
  actions = [],
  visibleColumns,
  deleteData,
  setDeleteData,
  additionalWheres = "",
  setAdditionalWheresN ,
  defaultAdditionalWhere = '',
  isPayrollEmployee = false,
  isAssignEmployee = false,
  isDashboard = true,
  isEmployeeManagement = true,
  checkboxAction = false,
  checkboxKey = null,
  supervisorId = 0,
  supervisorRole = "",
  selectedIds,
  setSelectedIds,
  customsubmitBtn,
  parentId,
    applicationName='',
  showFilterOptions = true,
  ...props
}) => {

  const dispatch = useDispatch();

  const {
    columns,
    loadingSearch,
    searchResultsV2,
  } = useSelector((state) => {
    return state.advanceSearchv2Reducer;
  });
  const {
    filter: storeFilter,
    additionalWhere: storeAdditionalWhere,
    pageSize: storePageSize,
    role: selectedRole
  } = useSelector((state) => {
    return state.CommonReducer;
  });
  const { results, rowCount } = searchResultsV2[tableName] == undefined ? { results: [], rowCount: 0 } : searchResultsV2[tableName];
  
  const [selectedRecordOption,setSelectedRecordOption]  = useState(defaultAdditionalWhere);
  const [selectedRecordType,setSelectedRecordType]  = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(storePageSize[tableName] || 100);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [sortData, setSortData] = useState(sort);
  const { userData, userData: { profile: { role } } = {} } = useAuth();
  // const [searchParams, setSearchParams] = useState([{"columnName":"parentId","operator":"=","value":parentId,"dataType":"VARCHAR"}]);
  const [searchParams, setSearchParams] = useState([]);
  const [localAdditionalWhere, setLocalAdditionalWhere] = useState(``);
  const [sortedColumns, setSortedColumns] = useState([]);

  const [clearCheckBox, setClearCheckBox] = useState(null);
  const [statusFilter, setStatusFilter] = useState(['all']);
  const [radioValue, setRadioValue] = React.useState("all");

  const navigate = useNavigate();
  const location = useLocation();
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [disableUnassign, setDisableUnassign] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [addSuperVisorOpen, setAddSuperVisorOpen] = useState(false);
  const [filterUpdate, setFilterUpdate] = useState();
  const { handleSubmit, control, getValues, reset, setValue } = useForm({
    defaultValues: {
      ...INITIAL_DATA,
    },
  });
  const [error, setError] = useState({});
 
    
    const response = {status:""}
    const [responsed, setResponsed] = useState("")
    const isFetchingSupervisorDetails = false
    const [supervisorObject, setSupervisorObject] = useState({})
    const [addRole, setAddRole] = useState({})

  const  isdepartmentsBySupervisorOrTimekeeperLoading = false
  const [departmentsBySupervisorOrTimekeeper,setDepartmentsBySupervisorOrTimekeeper]=useState([])



  const validationSchema = Yup.object().shape({
    StartDate: Yup.string().required("Active Date is required"),
    EndDate: Yup.string().required("End Date is required"),
  });

  const [formattedArray, setFormattedArray] = useState([]);
  useEffect(()=>{
    if(results.length){
      console.log("123123 Results::: ",results)
      let Array = results.map((item)=>{
        return {...item, "SSN": (item.SSN)?.replace(/^(\d{3})(\d{2})(\d{4})$/, "$1-$2-$3")?.toUpperCase()}
      })
      setFormattedArray(Array);
      //  setTimeout(() => {
      //   props.setShowDoc(true)  
      // }, 3000);
    }else{
      // setFormattedArray([]);

    }

  },[results])


//   const GetSupervisorDetailsByID = (async (payload) => {
//         try {
//             let response = await axios.get(`${process.env.REACT_APP_API_URL_PR}${GET_SUPERVISOR_DETAILS_BY_ID}?id=${payload}`,{
//                 headers: {
//                   "Content-Type": "application/json",
//                   Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//                 },
//               });
//              setSupervisorObject(response?.data.data)

//         } catch (error) {
           
//            console.log("erorr", error);
//         }
//     }
// );

// const AddUpdateAllSupervisorAndTimekeeperRole = (async (payload) => {
//   try {
//       let response = await axios.get(`${process.env.REACT_APP_API_URL_PR}${ADD_UPDATE_ALL_PAYROLL_EMPLOYEE}?id=${payload}`,{
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//           },
//         });
//         toast.success(response?.data.message);

//   } catch (error) {
     
//      console.log("erorr", error);
//   }
// }
// );

// const AddSupervisorAndTimekeeperRole = (async (payload) => {
//   try {
//       let response = await axios.post(`${process.env.REACT_APP_API_URL_PR}${ADD_ROLE_PAYROLL_EMPLOYEE}` ,payload,{
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//           },
//         });
//         toast.success(response?.data.message);
        
//         setAddRole(response.data)
//   } catch (error) {
     
//      console.log("erorr", error);
//      setAddRole({})
//   }
// }
// );

// const UnassignAllSupervisorEmployee = (async (payload) => {
//   try {
//       let response = await axios.post(`${process.env.REACT_APP_API_URL_PR}${UNASSIGN_ALL_PAYROLL_EMPLOYEE}` ,payload,{
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//           },
//         });
//         console.log("DSadaadsdda", response);
       
//   } catch (error) {
     
//      console.log("erorr", error);
    
//   }
// }
// );

// const UnassignSupervisorEmployee = (async (payload) => {
//   try {
//       let response = await axios.post(`${process.env.REACT_APP_API_URL_PR}${UNASSIGN_PAYROLL_EMPLOYEE}` ,payload,{
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//           },
//         });
//         console.log("DSadaadsdda", response);
//         setResponsed(response?.data)
       
//   } catch (error) {
     
//      console.log("erorr", error);
    
//   }
// }
// );



// const getAllDepartmentsBySupervisorOrTimekeeper =(async (payload) => {
//   try {
//       let response = await axios.post(`${process.env.REACT_APP_API_URL_PR}${URL_AdvanceSearch_GetRecords}/${payload?.location || 'Global'}` ,payload,{
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
//           },
//         });
      
//         console.log("DSadaadsdda", response);
//         setDepartmentsBySupervisorOrTimekeeper(response?.data?.results)



//   } catch (error) {
     
//      console.log("erorr", error);
//      setAddRole({})
//   }

//   })



  useEffect(() => {
    const d = {};
    let gridWhere = "";

    if (storeFilter[tableName] != null) {
      gridWhere = toSQLExpression(storeFilter[tableName]);
    }

    const filterCnd = `(${statusFilter.map(e => CONDITIONS[e]).join(' OR ')})`;

    if (gridWhere !== "") {
      if (filterCnd != '()') {
        d[tableName] = `${gridWhere} AND ${filterCnd}`;
      } else {
        d[tableName] = gridWhere;
      }
    } else {
      if (filterCnd != '()') {
        d[tableName] = filterCnd;
      }
    }
 
    let newWhere = '';
    if(selectedRecordOption){
      newWhere = `   ${selectedRecordOption} `
    }
    //  setAdditionalWheresN(`${newWhere}`)
    if (additionalWheres) {
      d[tableName] = d[tableName] ? `${d[tableName]} AND ${newWhere}` : ` ${newWhere}`;
    }
    console.log(d[tableName]," 111 ",additionalWheres," check filter update",d[tableName]);
     
    d[tableName] =  newWhere;

 console.log(d[tableName] ,"check love filter update",d ,'localadd',localAdditionalWhere);
 setLocalAdditionalWhere(d[tableName]);
    dispatch(setAdditionalWhere(d));
  }, [filterUpdate]);

  useEffect(() => {
    setTimeout(() => {
        setFilterUpdate(new Date());
    }, 100)
}, [storeFilter[tableName], statusFilter, additionalWheres,selectedRecordOption]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    setPageSize(100);
  };
  const handleFilterChange = (data) => {
    console.log("add it",selectedRecordOption +' and '+data);
    
    setAdditionalWhere(selectedRecordOption +' and '+data);
    // setAdditionalWhere(data);
    setPage(1);
    setPageSize(100);
  };
  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  // const handleClick = (event) => {
  //   const { value } = event.target;
  //   if (value === radioValue) {
  //     setRadioValue("");
  //     setStatusFilter(statusFilter.filter(e => e !== value));
  //   } else {
  //     const filteredData = statusFilter.filter(e => e != radioValue)
  //     setStatusFilter([...filteredData, value]);
  //     setRadioValue(value);
  //   }
  // }

  useEffect(() => {
    if (!!columns.length && !!visibleColumns.length) {
      console.log("123123 visibleColumns ::: ",visibleColumns, userData)
      setSortedColumns(
        filterAllowedColumn(userData, visibleColumns),
        ""
      );
    }
  }, [columns, visibleColumns]);

  const handleDelete = () => {
    if (window.confirm(`Are you sure to unassign ${isAllSelected ? 'all' : 'selected'} Employee(s)?`)) {
      if (isAllSelected) {
        const payload = {
          "supervisorId": supervisorId,
          "tableName": tableName,
          "searchParams": "[]",
          "columns": "*",
          "sortData": '',
          "additionalWhere": localAdditionalWhere,
          "qID": 0,
          "location": "global",
          "id": tableName
        };
        // UnassignAllSupervisorEmployee(payload)
      } else {
        const payload = [];
        selectedEmployees.map((employee, index) => {
          const transformedObject = {
            SupervisorId: supervisorId,
            EmployeeId: employee,
          };
          payload.push(transformedObject);
        });
        // UnassignSupervisorEmployee(payload)
      }
    }
  };

  const handleAdditionalEmployees = () => {
    if (supervisorObject?.supervisionRole == "Supervisor") {
      navigate(`/assign-supervisor-employees/${supervisorId}`);
    } else {
      navigate(`/assign-timekeeper-employees/${supervisorId}`);
    }
  };

  useEffect(() => {
    if (responsed?.status == 200 || addRole?.status == 200) {
      setDeleteData({ dt: new Date() });
      setSelectedEmployees([]);
      setClearCheckBox({ checkbox: true });
      // dispatch(resetPayrollEmployee());
      setResponsed("")
      setAddRole("")
      // GetSupervisorDetailsByID(supervisorId)
    }
  }, [responsed, addRole]);

  useEffect(() => {
    if (isAssignEmployee && supervisorId != 0) {
      // GetSupervisorDetailsByID(supervisorId)
      // getAllDepartmentsBySupervisorOrTimekeeper({
      //   "tableName": "vw_Payroll_Department_By_Supervisor",
      //   "searchParams": "[]",
      //   "columns": "*",
      //   "pageNumber": 1,
      //   "pageSize": 999999,
      //   "location": "Global",
      //   "additionalWhere": `supervisorEmployeeID = ${supervisorId}`,
      // })
    }
  }, [supervisorId]);

  const onSubmit = async (data) => {
    try {
      await validationSchema.validate(data, { abortEarly: false });
      setError({});
      if (window.confirm(`Are you sure to add/update ${isAllSelected ? 'all Employees' : 'selected Employee(s)'}?`)) {
        if (isAllSelected) {
          const payload = {
            "searchParameter": {
              "tableName": tableName,
              "searchParams": "[]",
              "columns": "*",
              "sortData": '',
              "additionalWhere": localAdditionalWhere,
              "qID": 0,
              "location": "global",
              "id": tableName
            },
            "supervisorAddPayloadDTO": {
              SupervisorId: supervisorId,
              SupervisionRole: supervisorRole,
              StartDate: dayjs(data.StartDate).format("YYYY-MM-DD"),
              EndDate: dayjs(data.EndDate).format("YYYY-MM-DD"),
            },
            "operation": location?.pathname?.includes("assign") ? "add" : "update"
          };
          // AddUpdateAllSupervisorAndTimekeeperRole(payload)
        } else {
          const payload = [];
          selectedEmployees.map((employee, index) => {
            const tranformed = {
              SupervisorId: supervisorId,
              EmployeeId: employee,
              SupervisionRole: supervisorRole,
              StartDate: dayjs(data.StartDate).format("YYYY-MM-DD"),
              EndDate: dayjs(data.EndDate).format("YYYY-MM-DD"),
            };
            payload.push(tranformed);
          });
          // AddSupervisorAndTimekeeperRole(payload)
        }
      }
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((fieldError) => {
        validationErrors[fieldError.path] = fieldError.message;
      });
      setError(validationErrors);
    }
  };

  const handleAssignSupervisorButton = () => {
    if (window.confirm(`Are you sure want to assign ${isAllSelected ? 'all Employees' : 'selected Employee(s)'} to supervisor?`)) {
      setAddSuperVisorOpen(true)
    }
  };

    const filterLayout =   <div className="pt-1 pb-1 text-center">
                         <Grid item xs={12} md={6}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              value={selectedRecordType} 
                              onChange={(event)=>{ 
                                setSelectedRecordType(event.target.value)
                                setSelectedRecordOption(defaultAdditionalWhere + ' '+ event.target.value)
                                // if(event.target.value){
                                //   setSearchParams
                                // }
                              }}
                              row
                            >
                              <FormControlLabel
                                value=""
                                control={<Radio />}
                                label="All Applicants"
                              />
                              <FormControlLabel
                                value=" and Job_Order_Number is  null"
                                control={<Radio />}
                                label="Not Assigned Joborder"
                              />
                              <FormControlLabel
                                value=" and Job_Order_Number is not null"
                                control={<Radio />}
                                label="Assigned Joborder"
                              />
                               
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </div>
  return (
    <ErrorBoundary>
      <Fragment>
        {/* {(
          isAddingRole ||
          isFetchingSupervisorDetails) && <LoadingPanel />} */}
        {/* <Container fluid={true}> */}
          <Row >
            <Col sm="12" className="page-contentx">
              <Card>
                <CardBody style={{padding:"5px"}}>
                  {/* {isPayrollEmployee && (
                    <div className="d-flex justify-content-center align-items-center gap-4">
                      <FormControl>
                        <RadioGroup
                          row
                          name="radio"
                          value={radioValue ?? ""}
                          onChange={handleClick}
                        >
                          <FormControlLabel
                            value="all"
                            control={<Radio className="p-2" />}
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                All
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Supervisor"
                            control={<Radio className="p-2" />}
                            label={
                              <Typography variant="body1" fontWeight="bold">
                                Show Only Supervisor
                              </Typography>
                            }
                          />
                         
                        </RadioGroup>
                      </FormControl>
                    </div>
                  )} */}

                  {isAssignEmployee && (
                    <>
                      <div style={{ fontSize: "20px",padding:"5px" }}>
                        <b> {supervisorObject?.supervisionRole || 'Employee'} details </b>
                      </div>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        width={"100%"}
                        alignItems={"center"}
                        marginTop={"10px"}
                        padding={"5px"}
                      >
                        <Box width={"100%"}>
                          <Box
                            width={"100%"}
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent="left"
                            flexWrap={"wrap"}
                            gap={4}
                          >
                            <div>
                              Employee Id:{" "}
                              <b>
                                {supervisorObject?.supervisorEmployeeId ||
                                  "N/A"}
                              </b>
                            </div>
                            <div>
                              Employee Name:{" "}
                              <b>{supervisorObject?.employeeName || "N/A"}</b>
                            </div>
                            <div>
                              Department:{" "}
                              <b>{supervisorObject?.departmentName || "N/A"}</b>
                            </div>
                            <div>
                              Position:{" "}
                              <b>{supervisorObject?.positionName || "N/A"}</b>
                            </div>
                          </Box>
                          <Box
                            width={"100%"}
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent="space-between"
                            alignItems={"center"}
                            marginTop={"10px"}
                            flexWrap={"wrap"}
                            gap={4}
                          >
                            <Box
                              display={"flex"}
                              flexDirection={"row"}
                              justifyContent="left"
                              flexWrap={"wrap"}
                              gap={4}
                            >
                              <div>
                                No. of Employees Assigned:{" "}
                                <b>
                                  {supervisorObject?.noOfEmployeeAssigned ||
                                    "N/A"}
                                </b>
                              </div>
                            </Box>
                          </Box>
                        </Box>
                      </Box>

                      <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} className="mt-2" style={{padding:"5px"}}>
                          <Grid item sm={12} lg={2} md={6}>
                            <Controller
                              name={"StartDate"}
                              control={control}
                              render={({
                                field: { onChange, value, name },
                              }) => (
                                <DatePicker
                                  name={name}
                                  value={value}
                                  onChange={(value) => {
                                    const formValues = getValues();
                                    setDisableUnassign(formValues.EndDate != null || value != null);
                                    reset({
                                      ...formValues,
                                      StartDate: value,
                                      EndDate:
                                        formValues.EndDate > value
                                          ? formValues.EndDate
                                          : value,
                                    });
                                  }}
                                  label={"Active Date"}
                                  placeholder={"MM/DD/YYYY"}
                                  dateFormat={"MM/DD/YYYY"}
                                  errorMessage={!value && error["StartDate"]}
                                  disablePast={true}
                                  disableHighlightToday={true}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item sm={12} lg={2} md={6}>
                            <Controller
                              name={"EndDate"}
                              control={control}
                              render={({
                                field: { onChange, value, name },
                              }) => (
                                <DatePicker
                                  name={name}
                                  value={value}
                                  onChange={(e) => {
                                    onChange(e);
                                    setDisableUnassign(getValues('StartDate') != null || e != null);
                                  }}
                                  variant={"sm"}
                                  label={"End Date"}
                                  placeholder={"MM/DD/YYYY"}
                                  dateFormat={"MM/DD/YYYY"}
                                  errorMessage={!value && error["EndDate"]}
                                  disablePast={true}
                                  minDate={dayjs(getValues("StartDate"))}
                                  disableHighlightToday={true}
                                />
                              )}
                            />
                          </Grid>

                          <Grid
                            item
                            sm={12}
                            md={8}
                            lg={6}
                            className="d-flex align-items-center justify-content-start ml-2 flex-row w-full gap-2"
                          >
                            <CustomButton
                              text={`${location.pathname.includes("assign")
                                ? "Assign"
                                : "Assign"
                                } Employees`}
                              onClick={handleSubmit(onSubmit)}
                              icon={faSave}
                              style={{ fontSize: "14px" }}
                              disabled={selectedEmployees?.length == 0}
                            />
                            {!location.pathname.includes("assign") && (
                              <>
                                <CustomButton
                                  text="Unassign Employees"
                                  onClick={handleDelete}
                                  icon={faTrash}
                                  style={{ fontSize: "14px" }}
                                  disabled={!selectedEmployees?.length || disableUnassign}
                                />
                                <CustomButton
                                  text="Assign to Supervisor"
                                  onClick={handleAssignSupervisorButton}
                                  icon={faPlus}
                                  style={{ fontSize: "14px" }}
                                  disabled={!selectedEmployees?.length || disableUnassign}
                                />
                              </>
                            )}
                          </Grid>

                          {!location.pathname.includes("assign") ? (
                            <Grid
                              item
                              sm={12}
                              md={4}
                              lg={2}
                              className="d-flex align-items-center justify-content-end ml-2 flex-row w-full"
                            >
                              <Link
                                component="button"
                                variant="body2"
                                onClick={handleAdditionalEmployees}
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                  style={{
                                    marginRight: "4px",
                                  }}
                                  size={40}
                                /> Add Additional Employees
                              </Link>
                            </Grid>
                          ) : (
                            <Grid
                              item
                              sm={12}
                              md={4}
                              lg={2}
                              className="d-flex align-items-center justify-content-end ml-2 flex-row w-full"
                            >
                              <Link
                                component="button"
                                variant="body2"
                                onClick={(() => navigate(`/supervisor-employees/${supervisorId}`))}
                              >
                                <FontAwesomeIcon
                                  icon={faEye}
                                  style={{
                                    marginRight: "4px",
                                  }}
                                  size={40}
                                /> View Assigned Employees
                              </Link>
                            </Grid>
                          )}
                        </Grid>
                        {!location.pathname.includes("assign") && <Grid container spacing={2}>
                          <Grid item sm={12} md={4}>
                            <CustomAutocomplete
                              label="Select Department"
                              name="department"
                              options={departmentsBySupervisorOrTimekeeper}
                              isLoading={isdepartmentsBySupervisorOrTimekeeperLoading}
                              labelName={"Department"}
                              keyName={"Department"}
                              onChange={(val) => {
                                if (val && val != "ALL") {
                                  setLocalAdditionalWhere(`${localAdditionalWhere} AND [DepartmentName] like '%${val.replaceAll("'", "''")}%' `)
                                } else {
                                  setLocalAdditionalWhere(prev => (prev || '').split("AND").filter(e => !e.includes('DepartmentName')).join(' AND '))
                                }
                              }}
                            />
                          </Grid>
                        </Grid>
                        }
                      </form>
                    </>
                  )}

                  <Row>
                     
                    <Col sm="12" className="page-content">
                      <AdvanceSearch
                        id={tableName}
                        gridId={tableName}
                        location="global"
                        columnLocation="global"
                        columnList={"*"}
                        columnRefernces={[]}
                        tableName={tableName}
                        additionalWhere={localAdditionalWhere}
                        searchParams={searchParams}
                        forceParams={searchParams}
                        expanded={true}
                        sortData={sortData}
                        pageNumber={page}
                        pageSize={pageSize}
                        chooseFilterMethod={chooseFilterMethod}
                        deleteData={deleteData}
                        role={selectedRole}
                        defaultAdditionalWhere={selectedRecordOption}
                        applicationName = {applicationName}
                      />
                      <div>
                        {sortedColumns.length > 0 && results && (
                          <TelerikDataTable
                            id={tableName}
                            gridId={tableName}
                            isDashboard={isDashboard}
                            pageSize={pageSize}
                            totalCount={rowCount}
                            skip={(page - 1) * pageSize}
                            take={pageSize}
                            // data={results || []}
                            data={results.length?formattedArray?.length ? formattedArray : results || []:[]}
                            sortData={sortData}
                            onFilterChange={handleFilterChange}
                            onSortChange={handleSortChange}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            selectedColumns={sortedColumns}
                            setSortedColumns={setSortedColumns}
                            loading={loadingSearch || isLoading}
                            isEmployeeManagement={isEmployeeManagement}
                            actions={actions}
                            setChooseFilterMethod={setChooseFilterMethod}
                            chooseFilterMethod={chooseFilterMethod}
                            handleClick={() => { }}
                            checkboxAction={checkboxAction}
                            handleSelectCheckbox={setSelectedIds}
                            checkboxKey={checkboxKey}
                            clearSelectedCheckbox={clearCheckBox}
                            handleSelectAll={setIsAllSelected}
                            customsubmitBtn = {customsubmitBtn}
                            filterLayout = {showFilterOptions ? filterLayout : null}
                            defaultAdditionalWhere={selectedRecordOption}

                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        {/* </Container> */}
       
      </Fragment>
    </ErrorBoundary>
  );
};

export default DataTable;
